module.exports = __webpack_public_path__ + "img/Loading Icon - white.6a7e013d.svg";